var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { icons } from './icons.js';
import { style } from './styles.js';
import { bemClass } from '@idme/component-utilities';
const sizeMap = {
    small: 20,
    medium: 24,
    large: 32,
};
let Icon = class Icon extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Color of the icon
         */
        this.color = undefined;
        /**
         * Description of the icon
         */
        this.description = '';
        /**
         * Label of the icon
         */
        this.label = '';
        /**
         * Name of the icon from the feather icon library
         */
        this.name = undefined;
        /**
         * Size of the icon
         */
        this.size = 'medium';
    }
    renderIcon() {
        if (!this.name || !(this.name in icons)) {
            return nothing;
        }
        const iconClasses = bemClass('icon', undefined, Object.assign({}, (this.color && { [this.color]: true })));
        const icon = {
            name: this.name,
            content: icons[this.name],
            attributes: Object.assign(Object.assign({ class: iconClasses, height: sizeMap[this.size], 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-width': 2, viewBox: '0 0 24 24', width: sizeMap[this.size], xmlns: 'http://www.w3.org/2000/svg', display: 'block' }, (!this.label && !this.description && { 'aria-hidden': 'true' })), { role: 'img' }),
        };
        return html `${this.createSVG(icon)}`;
    }
    createSVG(icon) {
        const _a = icon.attributes, { xmlns } = _a, restAttributes = __rest(_a, ["xmlns"]), { content } = icon;
        const svg = this.createNSElementWithProperties(xmlns, 'svg', restAttributes);
        svg.innerHTML = content;
        if (this.description) {
            const descNode = document.createElement('desc');
            descNode.innerHTML = this.description;
            descNode.id = 'icon-desc';
            svg.setAttribute('aria-labelledby', 'icon-desc');
            svg.prepend(descNode);
        }
        if (this.label) {
            const titleNode = document.createElement('title');
            titleNode.innerHTML = this.label;
            titleNode.id = 'icon-title';
            svg.setAttribute('aria-labelledby', `${this.description ? 'icon-title icon-desc' : 'icon-title'}`);
            svg.prepend(titleNode);
        }
        return svg;
    }
    createNSElementWithProperties(namespace, elementName, properties = {}) {
        const element = document.createElementNS(namespace, elementName);
        for (const property of Object.keys(properties)) {
            properties[property] &&
                element.setAttributeNS(null, property, properties[property]);
        }
        return element;
    }
    render() {
        return html `${this.renderIcon()} `;
    }
};
Icon.styles = style;
__decorate([
    property()
], Icon.prototype, "color", void 0);
__decorate([
    property()
], Icon.prototype, "description", void 0);
__decorate([
    property()
], Icon.prototype, "label", void 0);
__decorate([
    property()
], Icon.prototype, "name", void 0);
__decorate([
    property()
], Icon.prototype, "size", void 0);
Icon = __decorate([
    customElement('idme-icon')
], Icon);
export { Icon };
//# sourceMappingURL=index.js.map